import {
  GET_LABREQUESTDELIVERYRESULT_FAIL,
  GET_LABREQUESTDELIVERYRESULT_SUCCESS,
  GET_LABREQUESTDELIVERYRESULTS_FAIL,
  GET_LABREQUESTDELIVERYRESULTS_SUCCESS,
  ADD_LABREQUESTDELIVERYRESULT_SUCCESS,
  ADD_LABREQUESTDELIVERYRESULT_FAIL,
  UPDATE_LABREQUESTDELIVERYRESULT_SUCCESS,
  UPDATE_LABREQUESTDELIVERYRESULT_FAIL,
  DELETE_LABREQUESTDELIVERYRESULT_SUCCESS,
  DELETE_LABREQUESTDELIVERYRESULT_FAIL,  
  SET_STATE_LABREQUESTDELIVERYRESULT
} from "./actionTypes";

const INIT_STATE = {
  labRequestDeliveryResults: [],
  labRequestDeliveryResult: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labRequestDeliveryResults = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABREQUESTDELIVERYRESULTS_SUCCESS:
      return {
        ...state,
        labRequestDeliveryResults: action.payload.labRequestDeliveryResults,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABREQUESTDELIVERYRESULT:
      return { ...state, loading: action.payload }

    case GET_LABREQUESTDELIVERYRESULTS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUESTDELIVERYRESULT_SUCCESS:
      return {
        ...state,
        labRequestDeliveryResults: [...state.labRequestDeliveryResults, action.payload],
      };

    case ADD_LABREQUESTDELIVERYRESULT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABREQUESTDELIVERYRESULT_SUCCESS:
      return {
        ...state,
        labRequestDeliveryResults: state.labRequestDeliveryResults.map(labRequestDeliveryResult =>
          labRequestDeliveryResult.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labRequestDeliveryResult }
            : labRequestDeliveryResult
        ),
      };

    case UPDATE_LABREQUESTDELIVERYRESULT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABREQUESTDELIVERYRESULT_SUCCESS:
      return {
        ...state,
        labRequestDeliveryResults: state.labRequestDeliveryResults.filter(
          labRequestDeliveryResult => labRequestDeliveryResult.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABREQUESTDELIVERYRESULT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUESTDELIVERYRESULT_SUCCESS:
      return {
        ...state,
        labRequestDeliveryResult: action.payload,
      };

    case GET_LABREQUESTDELIVERYRESULT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labRequestDeliveryResults;
